// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"624":"3d2b29b0","930":"a868aaec","5742":"3d2b29b0","6014":"6074acee"}[chunkId] + ".chunk.css";
};